import { Buffer } from 'buffer';
import crytpo from 'crypto-js';
import { FileWithPath } from 'react-dropzone';

type HashConfig = {
  file: FileWithPath;
  chunkSize: number;
};

const toHex = (string: string) => crytpo.enc.Hex.parse(string);

const bufferToHex = (chunk: ArrayBuffer) => {
  const serialisedBuffer = Buffer.from(chunk).toString('hex');
  return toHex(serialisedBuffer);
};

const md5 = (chunk: ArrayBuffer) => crytpo.MD5(bufferToHex(chunk)).toString();

export const calculateChunkSize = (size: number): number => 1024 * 1024 * size;

export const hashFile = async ({
  file,
  chunkSize,
}: HashConfig): Promise<string> => {
  if (file.size <= chunkSize) {
    const fileBuffer = await file.arrayBuffer();

    return md5(fileBuffer);
  }

  const md5Chunks = [];
  const numberOfChunks = Math.ceil(file.size / chunkSize);

  for (let i = 0; i < numberOfChunks; i++) {
    const chunkBuffer = await file
      .slice(i * chunkSize, (i + 1) * chunkSize)
      .arrayBuffer();

    md5Chunks.push(md5(chunkBuffer));
  }

  const concatenatedHash = md5Chunks.join('');
  const md5Hash = crytpo.MD5(toHex(concatenatedHash)).toString();

  return `${md5Hash}-${md5Chunks.length}`;
};
